import { render, staticRenderFns } from "./EmployeeTypeLabel.vue?vue&type=template&id=35232b0a&scoped=true"
import script from "./EmployeeTypeLabel.vue?vue&type=script&lang=ts"
export * from "./EmployeeTypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35232b0a",
  null
  
)

export default component.exports